import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

export type SectionLabelProps = {
  icon?: LucideIcon;
  /** Heading level when the label titles a section (default: a plain span). */
  as?: 'span' | 'h2' | 'h3' | 'h4';
  className?: string;
  children: ReactNode;
};

/** The pill that titles a card section ("INFORMATIONS SUR L'OUTIL"). */
export function SectionLabel({
  icon: Icon,
  as: Tag = 'span',
  className,
  children,
}: SectionLabelProps) {
  return (
    <Tag
      className={cn(
        'inline-flex items-center gap-1.5 self-start rounded-full border border-border/60 bg-muted/60 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-muted-foreground',
        className
      )}
    >
      {Icon && <Icon className="h-3 w-3" aria-hidden />}
      {children}
    </Tag>
  );
}
